import axios from 'axios'
import React, { Component } from 'react'
import { APIURL } from '../../../hoc/AxiosSetting/axios'
import S3FileUpload from 'react-s3';
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance';
import '../../../components/GeneralCss.css'
import swal from 'sweetalert';

export default class AuditAgremeents extends Component {
    constructor(props) {
        super(props)

        this.state = {
            filenameToview : "",
            data: {},
            listOfCompanies: {
                orgCode: 0,
                masterAgreementUrl: ""
            },
            config: {
                bucketName: process.env.REACT_APP_BUCKET_NAME,
                dirName: process.env.REACT_APP_DIR_NAME /* optional */,
                region: process.env.REACT_APP_REGION,
                accessKeyId: process.env.REACT_APP_ACCESS_ID,
                secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
            },
            buttonStatus: "none",
            downloadbuttonStatus: "none",
            uploadDocumentStatus: "none",
            uploadedDocumentStatus: "none",
            showFile: "Image",
            uploadedMasterAgreementURL: "",
            submitStatus: true,
            messageforvalidation :"none"
        }
        
        this.masteragreementUrlInput = React.createRef();
    }
    componentDidMount() {
        axios.get(APIURL + '/api/clientaccess/get/listofcompaniesmasteraggrementdata/'+localStorage.getItem("userCode"))
            .then(res => {
                this.setState({ data: res.data.response })
                
            })
    }
    handleChange = name => e => {
        var errorVar = e.target.name + "Error";
        const listOfCompaniesData = this.state.listOfCompanies;
        listOfCompaniesData[e.target.name] = e.target.value;
        var tempData = this.state.data
        var tempList = tempData.find(x => x.value === parseInt(e.target.value))
        this.setState({maAgreement : tempList.maAgreement ,orgCode : e.target.value})
        if (tempList) {
            if (tempList.maAgreement) {
                this.setState({ buttonStatus: "none", downloadbuttonStatus: "block", uploadDocumentStatus: "block", uploadedDocumentStatus: "none" })
            }
            if (tempList.maAgreement && tempList.masterAgreementUrl) {
                var uplodedFileName= tempList.masterAgreementUrl.split("/")
                var uplodedFileNameToView = uplodedFileName[4]
                this.setState({ uploadedMasterAgreementURL: tempList.masterAgreementUrl })
                this.setState({ buttonStatus: "none", downloadbuttonStatus: "block", uploadDocumentStatus: "none", uploadedDocumentStatus: "block",submitStatus:true,showFileNameToview: uplodedFileNameToView})
            }
            else {
                this.setState({ buttonStatus: "block", downloadbuttonStatus: "none", uploadDocumentStatus: "block", uploadedDocumentStatus: "none" })
             }
        }
        
        this.setState({
            listOfCompanies: listOfCompaniesData,
            [`${errorVar}`]: "", orgcode: e.target.value,
        })

    };
    generteAgrement = () => {
        this.setState({ buttonStatus: "none" , downloadbuttonStatus : 'block'})
        ToastInstance('Information', 'Please Wait Master Agreement is generating')
             return axios.get(APIURL+'/api/generatepdf/get/agreementpdf/'+this.state.orgcode, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        )
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `Master Agreement.pdf`
                link.click()
            })
    }
    removeDoc = () => {
        var tempData = this.state.listOfCompanies;
        tempData.masterAgreementUrl = ""
        this.setState({ listOfCompanies: tempData ,filenameToview :"" });
    }
    handlechnageMasterAgreement = (event) => {
        event.preventDefault();
        let newArr = this.masteragreementUrlInput.current.files[0];
        this.handleUpload(newArr);
    }
    checkFileExtension = (file) => {
        if (file) {
            if (file.match(/\.(jpg|jpeg|png|gif)$/)) {
                return "Image"
            } else if (file.match(/\.(pdf)$/)) {
                return 'pdf'
            }
        }
    }
    handleUpload = (file) => {
        if(file.size <= 131950 ){
            S3FileUpload
            .uploadFile(file, this.state.config)
            .then(data => {
                var tempData = this.state.listOfCompanies;
                tempData.masterAgreementUrl = data.location
                var docType = this.checkFileExtension(data.location)
                var file= data.key.split("/")
                var fileName = file[1];
                this.setState({ 
                                listOfCompanies: tempData, 
                                showFile: docType,
                                submitStatus:false ,
                                filenameToview : fileName ,
                                messageforvalidation : "none",
                                fileToUpload : data.location
                            });
            })
            .catch(err => console.error(err))
        }
        else{
            this.setState({filenameToview : "",messageforvalidation : "block"})
            
        }
    };
    downloadUploadPdf=()=>{
        const link = document.createElement('a');
        console.log("link",link)
        link.href = this.state.fileToUpload
        window.open(link)
    }
    postData = () => {
        var jsonRequest = {
            orgCode: this.state.orgcode,
            masterAgreementUrl: this.state.listOfCompanies.masterAgreementUrl,
        }
        console.log("json ", jsonRequest)
        axios
            .patch(APIURL + "/api/rfq/patch/maagreementUrl", jsonRequest)
            .then((res) => {
                if (res.data.errorCode === 0) {
                   
                    ToastInstance('Success', 'Master Agreement Updated')
                    window.location.href = "/"+localStorage.getItem("role")+'/view/viewauditagreements/'+this.state.orgCode
                }
                else {
                    ToastInstance('Error', 'Something Went Wrong')
                }
            })
            .catch(err => {
                ToastInstance('warning', 'Something Went Wrong..Please Try again')
            })

    }
    downloadPDF = () => {
        // this.setState({ downloadbuttonStatus: "none" })
        ToastInstance('Information', 'Please Wait Master Agreement is Re-generating')
         return axios.get(APIURL+'/api/generatepdf/get/viewagreementpdf/' + this.state.orgCode, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        ) 
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `Master Agreement.pdf`
                link.click()
            })

    }
    removeUplodedDoc = () => {
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
      })
        .then((willDelete) => {
            if (willDelete) {
                
                var jsonRequest ={
                    "orgCode": parseInt(this.state.orgcode),
               }
               console.log("jsonRequest",jsonRequest)
        axios.patch(APIURL + "/api/rfq/patch/deleteauditagreementurl",jsonRequest)
        .then((res) => {
         if (res.data.errorCode === 0) {
            this.setState({ uploadDocumentStatus: "block", uploadedDocumentStatus: "none", uploadedMasterAgreementURL: "", filenameToview:"" })
            
        }
        else {
            ToastInstance('Error', 'Something Went Wrong')
        }
    })
    .catch(err => {
        ToastInstance('warning', 'Something Went Wrong..Please Try again')
    })

}
})
}
    downloadPdf=()=>{
        const link = document.createElement('a');
        console.log("link",link)
        link.href = this.state.uploadedMasterAgreementURL
        window.open(link)
    }
    render() {
        const listOfCompaniess = this.state.data;
        let listOfCompaniesList = listOfCompaniess.length > 0 && listOfCompaniess.map((item, i) => {
            return (
                <option key={i} value={item.value}>{item.key}</option>
            )
        }, this)
        const FileMasterAgreement = () => (
            this.state.showFile === 'Image' ?
                <>
                    <img className="img-fluid" src={this.state.listOfCompanies.masterAgreementUrl} style={{ width: '80px', height: '80px' }} onClick={()=>this.downloadUploadPdf()}/>
                    <p>{this.state.filenameToview}</p>
                    <span>
                        <h6 onClick={() => this.removeDoc('masterAgreementUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                    </span>
                </>
                :
                this.state.showFile === 'pdf' ?
                    <div className="row">
                        <div className ="col-sm-12">
                        <img className="img-fluid" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} onClick={()=>this.downloadUploadPdf()} />
                        
                        <span>
                            <h6 onClick={() => this.removeDoc('masterAgreementUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                        </span>
                        </div>
                        <div className="row">
                            <span>{this.state.filenameToview}</span>

                        </div>
                        </div>
                 
                    :
                    <>
                        <input type='file' ref={this.masteragreementUrlInput} onChange={this.handlechnageMasterAgreement} />
                        <p style={{ fontSize: '10px', color: 'red' }}>Only Pdf and images are accpeted</p>
                    </>
        )
        return (
            <div>
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card-body" style={{minHeight:"450px"}}>
                                        <div className="row htmlpage">
                                            <div className="col-sm-12">
                                                <div className="row">
                                                    <label  className="formSingleElementLabel">Organization Name</label>
                                                    </div>
                                                    <div className="form1Row">
                                                    <div className="col-sm-11">
                                                        <select className="formSingleElementField" onChange={this.handleChange("orgCode")} name="orgCode" value={this.state.listOfCompanies.orgCode} >
                                                            <option value="-">Select</option>
                                                            {listOfCompaniesList}
                                                        </select>
                                                            {/* <Select
                                                                value={this.state.listOfCompanies.orgCode}
                                                                onChange={this.handleChange("orgCode")}
                                                                options={listOfCompaniesList}
                                                                name="orgCode"
                                                            /> */}
                                                    </div>
                                                    </div>
                                                    <div className="row mt-3" style={{float:"right"}}>
                                                    {
                                                        this.state.buttonStatus === "block" && this.state.downloadbuttonStatus === "none" ?
                                                            
                                                            <div className="col-sm-4" style={{width:"250px"}}>
                                                                <button type="submit" className="btn btn-primary" onClick={() => this.generteAgrement()} style={{ display: this.state.buttonStatus }}>Generate Agreement</button>
                                                            </div>
                                                            : this.state.buttonStatus === "none" && this.state.downloadbuttonStatus === "block" ?
                                                                <div className="col-sm-4" style={{width:"250px"}}>
                                                                    <button type="submit" className="btn btn-primary" onClick={() => this.downloadPDF()} style={{ display: this.state.downloadbuttonStatus }}>Regenerate Agreement</button>
                                                                </div>
                                                                : ""
                                                    }
                                                </div>
                                                <div className="row mt-3" style={{ display: this.state.uploadDocumentStatus }}>
                                                    <div className="row mt-5" >
                                                        <div className="col-sm-4"><label htmlFor="staticEmail" >Upload master Agreement</label></div>
                                                        <div className="col-sm-6">
                                                            {/* <p style={{color:"red" ,display:this.state.messageforvalidation}}>Please Select Size Which is less than 3 MB</p> */}
                                                            {
                                                            
                                                            this.state.listOfCompanies.masterAgreementUrl !== "" ?
                                                                <FileMasterAgreement />
                                                                :
                                                                <>
                                                                    <input type='file' ref={this.masteragreementUrlInput} onChange={this.handlechnageMasterAgreement} />
                                                                    
                                                                    <br></br>

                                                                </>
                                                        }</div>
                                                    </div>
                                                </div>
                                                <div style={{ display: this.state.uploadedDocumentStatus }}>
                                                    <div className="row mt-5" >
                                                        <div className="col-sm-4">

                                                            <label className="mt-4">
                                                                Uploaded Master Agreement
                                                            </label>

                                                         </div>
                                                        <div className="col-sm-6">
                                                            {
                                                                this.state.uploadedMasterAgreementURL.match(/\.(jpg|jpeg|png|gif)$/) ?
                                                                    <>
                                                                        <img className="img-fluid" src={this.state.uploadedMasterAgreementURL} style={{ width: '80px', height: '80px' }} />
                                                                       
                                                                        <span>
                                                                            <h6 onClick={() => this.removeDoc('masterAgreementUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                        </span>
                                                                        <span style={{fontSize:"13px"}}>{this.state.showFileNameToview}</span>
                                                                    </>
                                                                    :
                                                                    this.state.uploadedMasterAgreementURL.match(/\.(pdf)$/) ?
                                                                        <>
                                                                            <img className="img-fluid mt-3" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }}  onClick={()=>this.downloadPdf()}/>
                                                                           
                                                                            <span>
                                                                                <h6 onClick={() => this.removeUplodedDoc('masterAgreementUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                            </span>
                                                                            <span> <p style={{fontSize:"13px"}}>{this.state.showFileNameToview} </p></span>
                                                                        </>

                                                                        :
                                                                        ""
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer">
                            <div className="row">
                                <div className="col-sm-10"></div>
                                <div className="col-sm-2">
                                    <button type="submit" className="btn btn-primary float-right" onClick={() => this.postData()} >Submit</button>
                                </div>

                            </div>
                        </div>
                    </section>

                </div>
            </div>
        )
    }
}
